import { render, staticRenderFns } from "./NewsList.vue?vue&type=template&id=64005f1c"
import script from "../../services/news/news-list.js?vue&type=script&lang=js&external"
export * from "../../services/news/news-list.js?vue&type=script&lang=js&external"
import style0 from "../../assets/css/news/news-list.css?vue&type=style&index=0&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports